/**
 * Certificates
 */

export default function Certificates() {
    const selectors = {
        'tabs': '.certificates-tabs',
        'tab': '.certificates-name',
        'contentWrapper': '.certificates-wrapper',
        'content': '.certificates-content'
    };

    this.init = () => {
        this.handle();
    };

    this.move2Tab = ($tab, $parent) => {
        $parent.find(`${selectors.content}[data-tab="${$tab}"]`).removeAttr('hidden').siblings().attr('hidden', true);
    }

    this.handle = () => {
        jQuery(selectors.tabs).on('click', selectors.tab, (e) => {
            e.preventDefault();
            const $this = jQuery(e.currentTarget);
            let $tab = $this.data("tab");
            let $parent = $this.closest(selectors.tabs);
            $this.addClass('active').siblings().removeClass('active');
            this.move2Tab($tab, $parent);
        })
    }
}

// export default function Certificates() {
//     const selectors = {
//         'tabs': '.certificates-tabs',
//         'tab': '.certificates-name',
//     };

//     this.init = () => {
//         this.handle();
//     };

//     this.move2Tab = ($tab, $parent) => {
//         $parent.find(`.certificates-content[data-tab="${$tab}"]`).removeClass('hidden').siblings().addClass('hidden');
//     }

//     this.handle = () => {
//         jQuery(selectors.tabs).on('click', selectors.tab, (e) => {
//             e.preventDefault();
//             const $this = jQuery(e.target);
//             let $tab = $this.data("tab");
//             let $parent = $this.closest(selectors.tabs);
//             $this.addClass('active').siblings().removeClass('active');
//             this.move2Tab($tab, $parent);
//         })
//     }


// }
